import { verifyEmailRegister, reSendEmail, checkValidate } from '@/apis/register';
import { REGISTER } from '../mutation-types';

export const state = {
  verifyEmailRegister: '',
  userInfo: {
    email: null,
    email_confirmation: null,
    password: null,
    password_confirmation: null,
    license_number_first: null,
    license_number_mid: null,
    license_number_last: null,
    business_name: null,
    business_name_kana: null,
    representative_name: null,
    representative_name_kana: null,
    license_scan_file: [],
    license_scan_file_name: null,
    copy_of_register: [],
    copy_of_register_name: null,
    business_type: null,
    post_code: null,
    prefectures: null,
    city: null,
    street: null,
    building: null,
    phone_number: null,
    guarantee_association: null,
    homepage: null,
    receive_email_info: null,
    license_start_date: null,
    license_expire_date: null,
  },
  sendEmail: '',
  checkValidate: '',
  index: 0,
};

export const getters = {
  userInfo: state => state.userInfo,
  sendEmail: state => state.sendEmail,
  index: state => state.index,
};

export const mutations = {
  changeIndex(state, index) {
    state.index = index;
  },
  [REGISTER.VERIFY_EMAIL_REGISTER](state, data) {
    state.verifyEmailRegister = data;
  },
  [REGISTER.RE_SEND_EMAIL](state, data) {
    state.sendEmail = data;
  },
  [REGISTER.REGISTER_VALIDATE](state, data) {
    state.checkValidate = data;
  },
  [REGISTER.RESET_DATA](state, data) {
    state.userInfo = {
      email: null,
      email_confirmation: null,
      password: null,
      password_confirmation: null,
      license_number_first: null,
      license_number_mid: null,
      license_number_last: null,
      business_name: null,
      business_name_kana: null,
      representative_name: null,
      representative_name_kana: null,
      account_name: null,
      account_name_kana: null,
      department: null,
      license_scan_file: [],
      license_scan_file_name: null,
      copy_of_register: [],
      copy_of_register_name: null,
      business_type: null,
      post_code: null,
      prefectures: null,
      city: null,
      street: null,
      building: null,
      phone_number: null,
      guarantee_association: null,
      homepage: null,
      receive_email_info: null,
      license_start_date: null,
      license_expire_date: null,
    };
  }
};

export const actions = {
  async verifyEmailRegister({ commit }, payload) {
    const res = await verifyEmailRegister(payload);
    if (res.error) {
      return res;
    }
    commit(REGISTER.VERIFY_EMAIL_REGISTER, res);

    return false;
  },

  async reSendEmail({ commit }, payload) {
    const res = await reSendEmail(payload);
    if (res.error) {
      return res;
    }
    commit(REGISTER.RE_SEND_EMAIL, res);
    return false;
  },

  async checkValidate({ commit }, payload) {
    const res = await checkValidate(payload);
    if (res.error) {
      return res;
    }
    commit(REGISTER.REGISTER_VALIDATE, res);
    return false;
  },

  async removeData({ commit }) {
    commit(REGISTER.RESET_DATA);
  }

};
